import { IApplicationState } from '../../types/redux';

export function selectPromoInventory(state: IApplicationState) {
  return state.promoInventory;
}
